import React, { Component } from "react";
import renewAuthSession from "AuthLogin/renewAuthSession";
import Header from "components/header";
import { getProfileDetail } from "./services/getUserDetail";
import Loader from "components/loader";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import checkUserPermission from "utils/checkUserPermission";

// getClientConfig is a key in the client config json file src/config/clientConfig.json
import { getClientConfig } from "services/clientConfig";

const mapStateToProps = state => {
  const {
    SUCCESS_USER_PROFILE,
    CLIENT_CONFIG_SUCCESS,
    CLIENT_CONFIG_LOADING,
    LOADING_USER_PROFILE
  } = state;

  return {
    ...SUCCESS_USER_PROFILE,
    ...CLIENT_CONFIG_SUCCESS,
    ...CLIENT_CONFIG_LOADING,
    ...LOADING_USER_PROFILE
  };
};

class App extends Component {
  checkAndRenewSession = () => {
    const { auth } = this.props;

    if (localStorage.getItem("isLoggedIn") === "true" || auth.isAuthCookiePresent()) {
      renewAuthSession(auth);
    }
  };

  componentDidUpdate() {
    const { userProfileMeta: profile, history } = this.props;
    checkUserPermission({
      location: history.location,
      profile
    });
  }

  async componentDidMount() {
    console.debug( 'App.componentDidMount() entry');
    //get clientinfo
    // @todo this call doesn't return anything. it can *only* have side-effects
    // this should be fixed.
    await this.props.getClientConfig();

    const { pathname } = this.props.history.location;
    // set initial session on app mount
    this.checkAndRenewSession();

    //check if token is present to get profile data
    if (localStorage.getItem("token")) {
      this.props.getProfileDetail();
    }

    let token = localStorage.getItem("token");
    let isLoggedIn = null !== token;

    console.debug( 'App.componentDidMount ', { isLoggedIn, token });

    // check if login route is hit directly and check whether user is already logged in
    if ( isLoggedIn && ["/", "/login"].indexOf(pathname) !== -1 ) {
      //remove email if exists
      localStorage.removeItem("password-reset-email");
      // redirect user from the `/` to the proper homepage and then to the last used tool
      this.props.history.push("/home");
    }
  }

  render() {
    //check if reset password route is active
    let checkIfUserLoggedIn =
      localStorage.getItem("isLoggedIn") && localStorage.getItem("token");
    let { pathname } = this.props.history.location;
    let resetPasswordRouteActive =
      !!!checkIfUserLoggedIn && pathname === "/password-reset";

    if (this.props.isProfileLoading || this.props.isClientConfigLoading) {
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );
    }

    if (
      (checkIfUserLoggedIn &&
        this.props.history.location.pathname !== "/logout") ||
      resetPasswordRouteActive
    ) {
      return (
        <>
          <Header
            {...this.props}
            resetPasswordRouteActive={resetPasswordRouteActive}
          />
          <ToastContainerStyled />
        </>
      );
    }

    return null;
  }
}

export default connect(mapStateToProps, {
  getProfileDetail,
  getClientConfig
})(App);

const LoaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${props => props.theme.COLOR.CONTAINER};
  z-index: 30;
`;

const ToastContainerStyled = styled(ToastContainer)`
  .Toastify__toast {
    display: block;
    position: relative;
    padding: 15px;
    min-height: 50px;
    border-radius: 3px;
  }

  .Toastify__close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 6px;
  }
`;
